<p-dialog [(visible)]="displayPastListsDialog" [focusOnShow]="false" [style]="{width: '620px'}"
          dismissableMask="true"
          header="Download past multicast lists" modal="true">
  <div *ngIf="researchForm" [formGroup]="researchForm">
    <p>Select a range of dates and click 'Download'. Only dates with a published multicast list are selectable.</p>
    <div class="past-range-controls">
      <label class="mb-0" for="past_date_filter_range_1">From date:</label>
      <p-calendar
        [disabledDates]="disabledDatesInCalendar"
        appendTo="body"
        formControlName="pastDateRange1"
        id="past_date_filter_range_1"
        panelStyleClass="sym-datepicker">
        <ng-template let-date pTemplate="date">
          <span [ngStyle]="{'color': '#2563eb', 'textDecoration': 'underline' }">{{ date.day }}</span>
        </ng-template>
      </p-calendar>
      <label class="mb-0" for="past_date_filter_range_2">To date:</label>
      <p-calendar
        [disabledDates]="disabledDatesInCalendar"
        appendTo="body"
        formControlName="pastDateRange2"
        id="past_date_filter_range_2"
        panelStyleClass="sym-datepicker">
        <ng-template let-date pTemplate="date">
          <span [ngStyle]="{'color': '#2563eb', 'textDecoration': 'underline' }">{{ date.day }}</span>
        </ng-template>
      </p-calendar>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button (click)="resetRangeDates()"
            icon="fa fa-refresh pr-2"
            iconPos="left"
            label="Reset"
            pButton
            type="button"></button>
    <button (click)="downloadRangeQrdMulticastList()"
            [disabled]="rangeDateNotSelected()"
            icon="fa fa-download pr-2"
            iconPos="left"
            id="download_past_file_with_date_range_button"
            label="Download"
            pButton
            type="button"></button>
  </ng-template>
</p-dialog>
<div class="layout-main">
  <div class="container-fluid">
    <div class="symbols-title-row">
      <h3 class="mb-0">
        <b>{{ newsOnly ? 'Quincy News: multicasts' : 'Raw: multicasts' }}</b>
      </h3>
      <div class="symbols-title-meta">
        <span *ngIf="updateOnDate">Updated on: {{ updateOnDate | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
      </div>
    </div>
    <div *ngIf="alertQedSymbolHasNotChanged " class="alert alert-danger alert-dismissible fade show">
      This information is outdated. Please verify that the {{ newsOnly ? 'Quincy News' : 'Raw (QRD)' }} Multicast list
      has not changed.
    </div>
    <div *ngIf="!alertQedSymbolHasNotChanged && researchForm" [formGroup]="researchForm">
      <div class="symbols-filter">
        <label class="symbols-filter-label mb-0" for="pop_filter">POP</label>
        <p-dropdown
          (onChange)="filterMulticastList()"
          [filter]="true"
          [options]="popList"
          [showClear]="true"
          formControlName="pop"
          id="pop_filter"
          placeholder="All POPs">
        </p-dropdown>
        <label class="symbols-filter-label mb-0" for="channel_filter">Channel</label>
        <input (input)="filterMulticastList()" class="form-control symbols-filter-input" formControlName="channel"
               id="channel_filter" placeholder="Filter…" type="text">
        <label class="symbols-filter-label mb-0" for="ip_address_1_filter">IP address</label>
        <div class="symbols-ip-group">
          <input (input)="filterMulticastList()" (paste)="onPasteIp($event)"
                 class="form-control symbols-filter-input symbols-ip-input" formControlName="ipAddress1"
                 id="ip_address_1_filter" type="text">
          <span class="symbols-ip-dot">.</span>
          <input (input)="filterMulticastList()" class="form-control symbols-filter-input symbols-ip-input"
                 formControlName="ipAddress2" id="ip_address_2_filter" type="text">
          <span class="symbols-ip-dot">.</span>
          <input (input)="filterMulticastList()" class="form-control symbols-filter-input symbols-ip-input"
                 formControlName="ipAddress3" id="ip_address_3_filter" type="text">
          <span class="symbols-ip-dot">.</span>
          <input (input)="filterMulticastList()" class="form-control symbols-filter-input symbols-ip-input"
                 formControlName="ipAddress4" id="ip_address_4_filter" type="text">
        </div>
        <label class="symbols-filter-label mb-0" for="platform_filter">Platform</label>
        <select (change)="filterMulticastList()" class="custom-select symbols-filter-select" formControlName="platform"
                id="platform_filter">
          <option *ngFor="let platform of platformOptions"
                  [attr.selected]="platformForm.value == platform ? true : null">{{ platform }}
          </option>
        </select>
        <div class="symbols-filter-right">
          <button (click)="downloadMenu.toggle($event)" icon="fa fa-download pr-2" iconPos="left"
                  id="download_csv_menu_button" label="Download CSV" pButton type="button"></button>
          <button (click)="resetTable()" icon="fa fa-refresh pr-2" iconPos="left" id="reset_button"
                  label="Reset" pButton type="button"></button>
        </div>
      </div>
      <p-overlayPanel #downloadMenu styleClass="sym-download-menu">
        <div class="symbols-menu">
          <button (click)="downloadCurrentQrdMulticastList(); downloadMenu.hide()" class="symbols-menu-item"
                  id="download_current_qrd_symbol_list" type="button">
            <i aria-hidden="true" class="fa fa-download"></i>This week's multicast list
          </button>
          <ng-container *ngIf="startDates">
            <div class="symbols-menu-sep"></div>
            <button (click)="displayPastListsDialog = true; downloadMenu.hide()" class="symbols-menu-item"
                    id="past_lists_menu_item" type="button">
              <i aria-hidden="true" class="fa fa-calendar"></i>Past multicast lists…
            </button>
          </ng-container>
        </div>
      </p-overlayPanel>
      <div>
        <div *ngIf="filteredQrdMulticastList.length === 0">
          <p class="symbols-empty-note">No data found for Multicast Groups definition</p>
        </div>
        <div *ngIf="filteredQrdMulticastList.length !== 0" class="symbols-market-table">
          <p-table [columns]="cols" [rowHover]="true" [tableStyle]="{'table-layout':'auto'}"
                   [value]="filteredQrdMulticastList" id="qrd-multicast-table">
            <ng-template pTemplate="caption">
              Multicast Groups definition
              <span class="symbols-table-count">{{ filteredQrdMulticastList.length }} channels</span>
            </ng-template>
            <ng-template let-columns pTemplate="header">
              <tr>
                <th *ngFor="let col of cols">
                  {{ col.header }}
                </th>
              </tr>
            </ng-template>
            <ng-template let-qrdMulticast pTemplate="body">
              <tr>
                <td *ngIf="channelsWithSamePop(qrdMulticast.pop)[0]?.qedChannel.name === qrdMulticast.qedChannel.name"
                    [attr.rowspan]="channelsWithSamePop(qrdMulticast.pop)?.length"
                    style="vertical-align: top">{{ qrdMulticast.pop }}
                </td>
                <td>{{ qrdMulticast.qedSymbolName }}</td>
                <td>{{ qrdMulticast.qedChannel.name }} <span *ngIf="!qrdMulticast.qedChannel.active"
                                                             style="color: red">(active: {{ qrdMulticast.qedChannel.active }}
                  )</span></td>
                <td>{{ qrdMulticast.rawQrdIpPort }}</td>
                <td>{{ qrdMulticast.rawQpdIpPort }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div>
        <div *ngIf="filteredSfiQrdMulticastList.length === 0">
          <p class="symbols-empty-note">No data found for SFI Multicasts</p>
        </div>
        <div *ngIf="filteredSfiQrdMulticastList.length !== 0" class="symbols-market-table">
          <p-table [rowHover]="true" [tableStyle]="{'table-layout':'auto'}" [value]="filteredSfiQrdMulticastList"
                   id="sfi-multicast-table">
            <ng-template pTemplate="caption">
              SFI Multicasts
              <span class="symbols-table-count">{{ filteredSfiQrdMulticastList.length }} channels</span>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th>POP</th>
                <th>Description</th>
                <th>{{ newsOnly ? 'Quincy News' : 'Qrd' }} Channel</th>
                <th>SFI Permissioning Id</th>
                <th>Platform</th>
                <th>Raw QRD IP/Port</th>
                <th>Raw QPD IP/Port</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-multicast>
              <tr>
                <td *ngIf="sfiRowsWithSamePop(multicast.pop)[0]?.qedChannel.name === multicast.qedChannel.name"
                    [attr.rowspan]="sfiRowsWithSamePop(multicast.pop)?.length"
                    style="vertical-align: top">{{ multicast.pop }}
                </td>
                <td>{{ multicast.qedSymbolName }}</td>
                <td>{{ multicast.qedChannel.name }}</td>
                <td>{{ multicast.sfiPermissionningId }}</td>
                <td>{{ multicast.platform }}</td>
                <td>{{ multicast.rawQrdIpPort }}</td>
                <td>{{ multicast.rawQpdIpPort }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>
